<template>
    <section>

        <div>
            <v-card
            flat
            tile
            color="#001b2b"
            class="d-flex  justify-center pt-5  "
            >

                    <v-card
                    class="d-flex justify-center flex-row my-2 mobile-grid  "
                    :color="color"
                    flat
                    style="max-width: 1500px;"
                    tile
                    width="80%"
                    >
                        <v-card 
                        :color="color"
                        class=" pa-2 d-flex mx-12 mobile-grid-card  "
                        flat
                        >
                            <v-img
                            max-height="150"
                            max-width="250"
                            contain
                            src="../../assets/img/escudo-nl2.webp"
                            ></v-img>
                        </v-card>
                        <!--  -->
                        <v-card
                        class="pa-2 white--text mx-12 mobile-grid-card mobile-width py-4 desktop-only"
                        outlined
                        max-width="25%"
                        flat
                        tile
                        :color="color"
                        >
                            <v-card
                            class="font-weight-bold white--text montserrat footer-text mobile-card-text"
                            :color="color"
                            flat
                            >
                                Dirección
                            </v-card>
                            <v-card class="white--text montserrat footer-text desktop-only " flat  :color="color">
                                Pabellón Ciudadano, Planta Baja.Washington 2000 Ote. C.P. 64010,Col. Obrera, Monterrey, N.L.
                                <div>
                                    <a href="https://www.nl.gob.mx" class="text-decoration-none white--text footer-text"   target="_blank">www.nl.gob.mx</a> 
                                </div> 
                            </v-card>
                        </v-card>
                        <!--  -->
                        <v-card
                        class="pa-2 white--text mx-12 mobile-grid-card mobile-grid-card-fix mobile-width py-4 desktop-only"
                        outlined
                        max-width="25%"
                        flat
                        elevation="0"
                        :color="color"
                        >
                            <v-card
                            class="font-weight-bold white--text montserrat footer-text mobile-card-text"
                            flat
                            :color="color"
                            >
                                Orientación y asesoría
                            </v-card>
                            <v-card class="white--text montserrat footer-text desktop-only" :color="color">
                                Teléfono: <a href="tel: 070">070</a><br>
                                Correo: <a href="mailto: 070@nuevoleon.gob.mx">070@nuevoleon.gob.mx</a><br>
                                Redes sociales: @070nuevoleon
                            </v-card>
                        </v-card>


                        <v-expansion-panels   accordion   class="mobile-only" multiple > 
                            <v-expansion-panel>
                                <v-expansion-panel-header :color="color" class="text-center mx-auto white--text footer-text d-flex justify-center">Dirección</v-expansion-panel-header>
                                <v-expansion-panel-content :color="color" class="white--text montserrat footer-text-2 d-flex justify-center text-center text-wrap">
                                    Pabellón Ciudadano, Planta Baja.Washington 2000 Ote. C.P. 64010,Col. Obrera, Monterrey, N.L.
                                </v-expansion-panel-content>
                            </v-expansion-panel>

                            <v-expansion-panel>
                                <v-expansion-panel-header :color="color" class="text-center mx-auto white--text footer-text d-flex justify-center">Orientación y asesoría</v-expansion-panel-header>
                                <v-expansion-panel-content :color="color" class="white--text montserrat footer-text-2 d-flex justify-center text-center text-wrap">
                                Teléfono: <a href="tel: 070">070</a><br>
                                Correo: <a href="mailto: 070@nuevoleon.gob.mx">070@nuevoleon.gob.mx</a><br>
                                Redes sociales: @070nuevoleon                            
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                        <v-card
                        outlined
                        tile
                        flat
                        max-width="25%"
                        class="pa-2 mx-12 mobile-grid-card mobile-width py-4"
                        :color="color"
                        >
                            <v-card
                            class="font-weight-bold white--text montserrat footer-text mobile-card-text"
                            tile
                            :color="color"
                            >
                                Redes Sociales
                            </v-card>
                            <v-card class=" montserrat social-mobile" :color="color" flat>
                                <a href="https://www.facebook.com/070nuevoleon/" class="text-decoration-none" target="_blank"> <v-icon left dark class="my-1 icon-border pa-2">  fab fa-facebook </v-icon> </a>
                                <a href="https://www.facebook.com/070nuevoleon/" target="_blank" class="text-decoration-none white--text footer-text desktop-only">Gobierno del Estado de Nuevo León</a>  <br>
                                <a href="https://twitter.com/070nuevoleon" class="text-decoration-none" target="_blank"> <v-icon left dark class="my-1 icon-border pa-2">  fab fa-twitter </v-icon> </a>
                                <a href="https://twitter.com/070nuevoleon" target="_blank" class="text-decoration-none white--text footer-text desktop-only">@nuevoleon</a>  <br>
                                <a href="https://www.youtube.com/user/GobiernoNuevoLeon" class="text-decoration-none" target="_blank"> <v-icon left dark class="my-1 icon-border pa-2">  fab fa-youtube </v-icon></a>
                                <a href="https://www.youtube.com/user/GobiernoNuevoLeon" target="_blank" class="text-decoration-none white--text footer-text desktop-only">@GobiernoNuevoLeon</a>
                            </v-card>
                        </v-card>


                    </v-card>

            </v-card>
    

        </div>
        <div>
            <v-card  flat tile class="white--text d-flex flex-row py-2 justify-center terminos-mobile py-7" :color="color2">
                <v-card
                    v-for="(items ,index) in terminosCondiciones"
                    :key="index"
                    class="pa-2 white--text px-5  montserrat "
                    outlined
                    tile
                    :color="color2"
                >
                <span v-if="index < 2"> {{items.text}}</span>
                <a v-else :class="[`white--text footer-aviso-text text-sm-body-2 montserrat text-decoration-none`]" :href="items.url " target="_blank" >{{items.text}}</a> 
                </v-card>
            </v-card>
        </div>
    </section>

</template>

<script>
export default {
    data: () => ({
        icons: [
        { icon:  'mdi-car-emergency' ,  nombre : 'Emergencias',         path : ''},
        { icon:  'mdi-phone' ,          nombre : 'Denuncia anónima',    path : ''},
        { icon:  'mdi-calendar' ,       nombre : 'Informatel y Locatel',path : ''},
        { icon:  'mdi-water' ,          nombre : 'Agua y drenaje',      path : ''},
        { icon:  'mdi-leaf' ,           nombre : 'Monitoreo ambiental', path : ''},
        ],
        items: [
        'default',
        'absolute',
        'fixed',
        ],
        footerLista: [
            {title: 'Dirección', text: 'Pabellón Ciudadano, Planta Baja.Washington 2000 Ote. C.P. 64010,Col. Obrera, Monterrey, N. L. www.nl.gob.mx'},
            {title: 'Soporte', text: '070@nuevoleon.gob.mx'},
            {title: 'Redes Sociales' , text: 'Gobierno del Estado de Nuevo León @070nuevoleon' } , 
        ],
        terminosCondiciones:[
            {text : '© ' + new Date().getFullYear() + ' Gobierno de Nuevo León', url: '', size: '4rem'},
            {text : 'Todos los derechos reservados', url: '', size: '1rem'},
            {text : 'Términos y condiciones', url: 'https://funcionario.nl.gob.mx/assets/pdf/terminos_condiciones.pdf', size: '1rem'},
            {text : 'Aviso de privacidad', url: 'https://www.nl.gob.mx/es/aviso-de-privacidad-integral-de-ventanilla-de-tramites-acceso-para-el-registro-de-usuarios', size: '1rem'},
            {text : 'Manual para registrarte e iniciar sesión', url: 'https://acceso.nl.gob.mx/panel_ciudadano/home/user_manual', size: '1rem'}
        ],
        padless: false,
        variant: 'default',
        color:'#001b2b',
        color2:'#FF8400',
        panel: [0, 1],
    }),
}
</script>

<style  scoped>
    
    .montserrat{  
        font-family: "Montserrat" !important;
    }
    .mobile-only{
        display: none;
    }

    @media only screen and (max-width: 770px) {
        .icon-border{
            border: 1px solid white;
            border-radius: 25px !important;
        }
        .terminos-mobile{
            display: flex;
            flex-direction: column !important;
            text-align: center;
        }
        .social-mobile{
            display: flex;
            justify-content: space-evenly;    
            padding-top: 1rem;
            padding-left: 2rem;
            padding-right: 2rem;
        }

        .mobile-card-text{
            text-align: center;
        }

        .mobile-width{
            width: 100%;   
            border-top: 1px solid #233944  !important;
        }

        .mobile-grid{
            flex-flow: wrap;
            width: 100% !important;
            margin-right: 0 !important;
            margin-left: 0 !important;
            padding-right: 0 !important;
            padding-left: 0 !important;
        }
        .mobile-grid-card{
            max-width: 100% !important;
            margin-left: unset !important;
            margin-right: unset !important;
        }

        .mobile-grid-card-fix{
            margin-right: -4 !important;
            margin-left: -4 !important;
        }

        .footer-text{
            font-size: 12px !important;
        }
        .footer-text-2{
            font-size: 11px !important;
        }
        .footer-aviso-text{
            font-size: 10px !important;
        }
        .desktop-only{
            display: none  !important;
        }
        .mobile-only{
            display: inline-block;
        }

    }
</style>
